
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights/first-class",
      function () {
        return require("private-next-pages/flights/first-class.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flights/first-class"])
      });
    }
  